(function () {
    const pagination = document.getElementById('pagination');
    if (!pagination) return;

    const startButton = document.getElementById('startBtn');
    const previousButton = document.getElementById('prevBtn');
    const nextButton = document.getElementById('nextBtn');
    const endButton = document.getElementById('endBtn');
    const pageLink = document.getElementById('pageLink');
    const paginationLimit = 5;

    // Data
    const pageCount = pagination.dataset.pagecount;
    let currentPage = pagination.dataset.actualpage;

    function disableBtn(li) {
        li.classList.add('disabled');
        li.setAttribute('aria-disabled', 'true');
        const a = li.querySelector('a');
        if (a) {
            a.removeAttribute('href');
            a.setAttribute('tabindex', '-1');
        }
    }
 
    function enableBtn(li) {
        li.classList.remove('disabled');
        li.removeAttribute('aria-disabled');
        const a = li.querySelector('a');
        if (a) a.setAttribute('tabindex', '0');
    }

    function updateNavButtons() {
        if (currentPage <= 1) {
            disableBtn(startButton);
            disableBtn(previousButton);
        } else {
            enableBtn(startButton);
            enableBtn(previousButton);
        }

        if (currentPage >= pageCount) {
            disableBtn(nextButton);
            disableBtn(endButton);
        } else {
            enableBtn(nextButton);
            enableBtn(endButton);
        }
        console.log('page Count', pageCount.length)
    }

    function createDots() {
        const li = document.createElement("li");
        li.classList.add("pageLink", "dots");
        li.textContent = '...';
        return li;
    }

    const updatePagination = () => {
        const list = document.querySelector('.pagination__list');
        const half = Math.floor(paginationLimit / 2);

        let start = Math.max(1, currentPage - half);
        let end = Math.min(pageCount, start + paginationLimit - 1);
        start = Math.max(1, end - paginationLimit + 1);

        list.querySelectorAll('.dots').forEach((d) => d.remove());

        const pageLis = list.querySelectorAll('.pageLink:not(.dots)');
        pageLis.forEach((li) => {
            const page = parseInt(li.querySelector('a').textContent, 10);
            li.style.display = page >= start && page <= end ? '' : 'none';
        });

        if (start > 1) {
            const firstVisible = [...pageLis].find(
                (li) => li.style.display !== 'none'
            );
            if (firstVisible) list.insertBefore(createDots(), firstVisible);
        }

        if (end < pageCount) {
            const nextBtnLi = document.getElementById('nextBtn');
            list.insertBefore(createDots(), nextBtnLi);
        }
    };

    
    updateNavButtons();
    updatePagination();
    updatePagination();
    
    window.addEventListener('DOMContentLoaded', () => {
        updateNavButtons();
        updatePagination();
        updatePagination();
    });
})();
